import { useMemo } from "react";
import { useLocation } from "react-router";

import GtmEvent from "web/Layout/Gtm/GtmEvent";

import getPageReferrer from "web/utils/system/GTM/getPageReferrer";

import Page404 from "./page404";

const Page404Container = () => {
  const location = useLocation();
  const gtmOptions = useMemo(() => {
    const pageReferrer = getPageReferrer(location);
    return {
      virtualPage: {
        cgroup1: "404",
        page_referrer: pageReferrer,
      },
      errorAccured: {
        page_referrer: pageReferrer,
        errorCode: "error 404",
        pagePath: location.pathname,
      },
    };
  }, [location, getPageReferrer]);

  return (
    <>
      <Page404 />
      <GtmEvent options={gtmOptions.virtualPage} withUrl />
      <GtmEvent eventName="error_accured" options={gtmOptions.errorAccured} />
    </>
  );
};

export default Page404Container;
